<p>settlement-detail works!</p>
